import { Link } from 'react-router-dom';

export function CTASection() {
  return (
    <section className="py-24 bg-gradient-to-br from-ocean-600 via-ocean-700 to-marine-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              어선 물품 공급의
              <br />
              새로운 기준을 경험하세요
            </h2>
            <p className="text-xl text-ocean-100 mb-8 leading-relaxed">
              전국의 우수한 제조업체와 직거래로 품질은 높이고 비용은 낮추세요.
              지금 가입하고 특별 혜택을 받아보세요.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <button className="px-8 py-4 bg-white text-ocean-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer">
                무료로 시작하기
              </button>
              <Link
                to="/contact"
                className="px-8 py-4 bg-ocean-500/20 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-ocean-500/30 transition-colors border border-white/30 whitespace-nowrap cursor-pointer flex items-center justify-center"
              >
                상담 문의하기
              </Link>
            </div>

            <div className="flex items-center space-x-6 text-ocean-100">
              <div className="flex items-center">
                <i className="ri-check-line text-2xl mr-2"></i>
                <span className="text-sm">신용카드 불필요</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-2xl mr-2"></i>
                <span className="text-sm">즉시 이용 가능</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-ship-2-line text-white text-2xl"></i>
              </div>
              <h3 className="text-white font-bold text-lg mb-2">선장·선주</h3>
              <p className="text-ocean-100 text-sm">
                전국의 제조업체를 발견하고 최적의 제품을 합리적인 가격에 구매하세요
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 mt-8">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-factory-line text-white text-2xl"></i>
              </div>
              <h3 className="text-white font-bold text-lg mb-2">제조업체</h3>
              <p className="text-ocean-100 text-sm">
                전국의 선장·선주에게 제품을 홍보하고 판로를 확대하세요
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 col-span-2">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-white font-bold text-lg mb-2">제조업체 입점 문의</h3>
                  <p className="text-ocean-100 text-sm">
                    우수한 제품을 보유하신 제조업체라면 지금 입점하세요
                  </p>
                </div>
                <Link
                  to="/contact"
                  className="px-6 py-3 bg-white text-ocean-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  입점 문의
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
